// AuthService.js

import axios from "axios";
import jwtDecode from "jwt-decode";
import AuthService from '../services/AuthService'
import store from '../store';
import keycloakService from "../services/KeycloakService";
import createAxiosInstance from "../interceptor/axiosInterceptor";
import appConfig from '@/config/appConfig';

const TOKEN_KEY = "jwt";
const instance = createAxiosInstance(appConfig.VUE_APP_AUTH_API_URL);
let haltPolling = false;

// const instance = axios.create({
//   baseURL: appConfig.VUE_APP_AUTH_API_URL,
// })



export default {
  generateOTP: async function (data) {
    try {
      console.log("generating otp", data);
      const response = await instance.post("generate-otp", data);
      if (response.status == 200) {
        return response.data.flag;
      }
    } catch (error) {
      if (error.response.status === 404) {
        alert(error.response.data.error);
        return error.response.success;
        // response.data.error
      } else {
        // handle other errors
        alert(error.response.data.error);

        //console.log('An error occurred:', error.message)
        return error.response.success;
      }
    }
  },

 isAuthenticationExist: async function (payload, abortController) {
  try {
    const response = await instance.post(
      `authenticationExist?accessId=${AuthService.getUserId()}`, 
      payload,
      {signal: abortController.signal} // Access signal directly
    );
    return response;
  } catch (error) {
    if (error.name === 'CanceledError') {
      return null; 
    }
    return error.response;
  }
},

  //only for registration form
  // async verifyOTP(data) {
  //   try {
  //     console.log("validate data", data)
  //     const response = await instance.post('validate-otp', data);
  //     console.log("varified response",response)

  //     if (response.data.success) {

  //       return response.data;
  //     }
  //   }
  //   catch (error) {
  //     alert(error.response.data.error)
  //   }
  // },

  async validateOTP(data) {
    try {
      console.log("validate data", data);
      const response = await instance.post("validate-otp", data);
      console.log("validate response", response);
      if (response.status == 200) {
        const { token, refreshToken } = response.data;
        store.dispatch('setUserId', response.data.userId)
        store.dispatch('setToken', token);
        store.dispatch('setRefreshToken', refreshToken);
        return response.data;
      } else {
        return response.data;
      }
    } catch (error) {
      console.log("validate otp error", error)
      alert(error.response.data.result);
    }
  },
  async verifySecondaryContact(data) {
    try {
      console.log("validate data", data,);
      const response = await instance.post(`verifySecondaryContact?accessId=${AuthService.getUserId()}`, data);
      console.log("validate response", response);
      if (response.status == 200) {
        return response.data;
      } else {
        return response.data;
      }
    } catch (error) {
      alert(error.response.data.result);
    }
  },

  logout: function () {
    this.stopPolling() // stop token polling when logout
    store.dispatch('clearAllStates');
  },
  getUser: function () {
    const token = this.getToken();
    if (token) {
      const decoded = jwtDecode(token);
      return decoded.user ?? decoded.username;
    }
    return null;
  },
  getToken: function () {
    return store.getters.token;
  },
  async verifyRefreshToken (currentRefreshToken) {
    try {
      return await instance.post('/verify-refresh-token', { currentRefreshToken });
    } catch (error) {
      console.error('Error while generating refresh token', error);
    }
  },
  getUserId: function () {
    return store.getters.userId;

  },
  isAuthenticated: function () {
    const token = this.getToken();
    const refreshToken = this.getRefereshToken();
    return store.getters.isAuthenticated && (!this.isTokenExpired(token) || !this.isTokenExpired(refreshToken));
  },
  isTokenExpired: function (token) {
    const decoded = jwtDecode(token);
    const expirationDate = new Date(decoded.exp * 1000);
    return expirationDate < new Date();
  },
  async validateKeycloakToken(code,state) {
    console.log('validate Keyclock', code)
    console.log('validate Keyclock state', state)
    try {
      const key = 'kc-callback-' + state;
      
      const codeVerifierString = localStorage.getItem(key);

      const codeVerifier = JSON.parse(codeVerifierString);
      const pkceCodeVerifier = codeVerifier.pkceCodeVerifier;
      const authorizationCode = code; 

      const params = new URLSearchParams({
        code: authorizationCode,
        code_verifier: pkceCodeVerifier
      });
      
      const response = await instance.get(`/keycloakAuth/validateToken?${params.toString()}`);
      console.log("validate response", response);
      if (response.status == 200) {
        if(response.data.flag){
          console.log('in response flag validate')
            const { token, refreshToken } = response.data;
            store.dispatch('setUserId', response.data.userId);
            store.dispatch('setToken', token);
            store.dispatch('setRefreshToken', refreshToken);
            this.startPolling();
            return response.data;
        }else{
          console.log('in response flag else validate')
           return response.data;
        }
        
      } else {
        console.log('response data',response.data)
        return response.data;
      }
    } catch (error) {
      console.log("validate otp error", error)
    }
  },
  startPolling() {
    let timeoutId = null;
    haltPolling = false;
    const poll = async () => {  
      if (this.isTokenExpired(store.getters.token)) {
        let retryCount = 1;
        const MAX_RETRY = 3;
        while (retryCount <= MAX_RETRY) {
          try {
            if(haltPolling) return;
            const response = await this.verifyRefreshToken(store.getters.refreshToken);
            const { accessToken } = response.data;
            store.dispatch("setToken", accessToken);
            break;
          }
          catch (error) {
            console.error("Failed to refresh token", error);
            if (retryCount < MAX_RETRY) {
              const delay = this.getBackoffDelay(retryCount);
              retryCount += 1;
              await new Promise(resolve => setTimeout(resolve, delay));
              continue;
            }
            haltPolling = true;
            window.dispatchEvent(new CustomEvent("app-auth-failure"));
            return;
          }
        }
      }
      if(haltPolling) return;
  
      // Recursively call itself
      timeoutId = setTimeout(poll, 30000);
      store.dispatch("setPollerId", timeoutId);
      return;
    };
  
    poll(); // Start polling
    return; // Store for later cancellation
  },
  
  stopPolling() {
    const pollerId = store.getters.pollerId
    if (pollerId) {
      haltPolling = true;
      clearTimeout(pollerId);
      store.dispatch("clearPollerId", pollerId);
    }
  },
  getMappedStatusInfo(){
    const status = store.getters?.userInfo?.status?.toLowerCase() ?? '';
    const statusMap = {
      'closed': { path: 'application-closed' },
    }
    return statusMap[status] ?? null;
  },
  getRefereshToken() {
    return store.getters.refreshToken;
  },
  getSourceUrl: async function (source) {
    try {
      const response = await instance.get('/getSourceUrl', {
        params: { source },
      });

      return response;
    } catch (error) {
      return error.response;
    }
  },

 getBackoffDelay: (attempt) => attempt * 5 * 1000 // 5s, 10s, 15s
  
};

